import { fetchApi } from '@/config/axiosSetting.ts';
import { IncidentDetailsMutationParams } from '@/modules/adjusterReportModules/IncidentDetails/queries/incidentDetails/property/incidentDetailsMutationProperty.types';

export const incidentDetailsMutationProperty = ({
  formData,
  id,
}: IncidentDetailsMutationParams) => {
  return fetchApi({
    method: 'PATCH',
    url: `/property/reports/${id}/accident_information/`,
    data: formData,
  });
};
export default incidentDetailsMutationProperty;
